import { all, call, put, takeEvery } from 'redux-saga/effects';
import * as types from './supplierTypeActionTypes';
import * as actions from './supplierTypeActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';
import { errorHandler } from '../../helpers/errorHandler';

function* getSupplierTypeSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getSupplierTypes, payload);
    yield put(actions.getSupplierTypeDataAction(data));
  } catch (e) {
    yield put(actions.getSupplierTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createSupplierTypeSaga(action) {
  try {
    const payload = action.payload.data;
    const { data } = yield call(endpoints.createSupplierType, payload);
    yield put(actions.createSupplierTypeDataAction(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: data.Result.ErrorDescription,
        variant: 'success',
      }));
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/suppliertype');
        }
      }, 2000);
    }
  } catch (e) {
    yield put(actions.createSupplierTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateSupplierTypeSaga(action) {
  try {
    const payload = action.payload.data;
    const { data } = yield call(endpoints.updateSupplierType, payload);
    yield put(actions.updateSupplierTypeDataAction(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: data.Result.ErrorDescription,
        variant: 'success',
      }));
      yield put(actions.getSupplierTypeRequestAction());
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/suppliertype');
        }, 1000);
      }
    }
  } catch (e) {
    yield put(actions.updateSupplierTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteSupplierTypeSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteSupplierType, action.payload.data);
    yield put(actions.deleteSupplierTypeDataAction(data));
    if (data.Result?.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: data.Result.ErrorDescription,
        variant: 'success',
      }));
      yield put(actions.getSupplierTypeRequestAction());
    }
  } catch (e) {
    yield put(actions.deleteSupplierTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* supplierTypeSaga() {
  yield all([
    takeEvery(types.GET_SUPPLIERTYPE_REQUEST, getSupplierTypeSaga),
    takeEvery(types.CREATE_SUPPLIERTYPE_REQUEST, createSupplierTypeSaga),
    takeEvery(types.UPDATE_SUPPLIERTYPE_REQUEST, updateSupplierTypeSaga),
    takeEvery(types.DELETE_SUPPLIERTYPE_REQUEST, deleteSupplierTypeSaga),
  ]);
}


